import { useState, useEffect } from "react";
import { Button } from "@/components/ui/button";
import { useIsMobile } from "@/hooks/use-mobile";
import { cn } from "@/lib/utils";

const StickyCTABar = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [hasAnimated, setHasAnimated] = useState(false);
  const isMobile = useIsMobile();

  useEffect(() => {
    const heroSection = document.querySelector("section");
    if (!heroSection) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        const shouldShow = !entry.isIntersecting;
        setIsVisible(shouldShow);
        if (shouldShow && !hasAnimated) {
          setHasAnimated(true);
        }
      },
      { threshold: 0, rootMargin: "-100px 0px 0px 0px" }
    );

    observer.observe(heroSection);
    return () => observer.disconnect();
  }, [hasAnimated]);

  const scrollToSection = (selector: string) => {
    document.querySelector(selector)?.scrollIntoView({ behavior: "smooth" });
  };

  if (!isVisible) return null;

  // Mobile bottom bar
  if (isMobile) {
    return (
      <div className={cn(
        "fixed bottom-0 left-0 right-0 z-50 bg-card/95 backdrop-blur-md border-t border-border shadow-lg p-3 animate-slide-up",
        hasAnimated && "pulse-attention"
      )}>
        <div className="flex gap-2">
          <Button
            variant="gold"
            size="sm"
            className="flex-1"
            onClick={() => scrollToSection("#kit-section")}
          >
            DIY Kit $99
          </Button>
          <Button
            variant="outline"
            size="sm"
            className="flex-1"
            onClick={() => scrollToSection("#templates-section")}
          >
            Templates
          </Button>
        </div>
      </div>
    );
  }

  // Desktop sticky nav
  return (
    <div className={cn(
      "fixed top-16 left-0 right-0 z-40 bg-card/95 backdrop-blur-md border-b border-border shadow-sm animate-slide-down",
      hasAnimated && "pulse-attention"
    )}>
      <div className="container-custom py-2">
        <div className="flex items-center justify-center gap-4">
          <Button
            variant="gold"
            size="sm"
            onClick={() => scrollToSection("#kit-section")}
            className="group"
          >
            DIY Kit $99
          </Button>
          <Button
            variant="outline"
            size="sm"
            onClick={() => scrollToSection("#templates-section")}
            className="hover:border-primary/50 transition-colors"
          >
            Templates
          </Button>
        </div>
      </div>
    </div>
  );
};

export default StickyCTABar;
